import { gql } from "@apollo/client";export default gql`query topicAggregate($parent_id: Int!) {
    topicAggregate: group_aggregate(where: {parent_id: {_eq: $parent_id}, type: {_eq: "topic"}}) {
        aggregate {
            count
        }
    }
}
`;
